module.exports = __webpack_public_path__ + "02aa029a4184f11181c3879911bc3ec5.png";